
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class AziendeDialog extends Serenity.EntityDialog<AziendeRow, any> {
        protected getFormKey() { return AziendeForm.formKey; }
        protected getIdProperty() { return AziendeRow.idProperty; }
        protected getLocalTextPrefix() { return AziendeRow.localTextPrefix; }
        protected getNameProperty() { return AziendeRow.nameProperty; }
        protected getService() { return AziendeService.baseUrl; }
        protected getDeletePermission() { return AziendeRow.deletePermission; }
        protected getInsertPermission() { return AziendeRow.insertPermission; }
        protected getUpdatePermission() { return AziendeRow.updatePermission; }

        protected form = new AziendeForm(this.idPrefix);
    }
}